import React from 'react';
import { NavLink } from 'react-router-dom';

import { createClassName } from 'utils/createClassName';

import './dashboardNavigationControlStyles.scss';

type Props = {
  to?: string;
  onClick?(): void;
  badgeNumber?: number;
};

export const DashboardNavigationControlComponent: React.FC<Props> = (props) => {
  const { to, badgeNumber, onClick, children } = props;

  const createDashboardNavigationControlClassName = createClassName(
    'dashboardNavigationControl'
  );

  const navLinkActiveClassName = createDashboardNavigationControlClassName(
    'navLink',
    { active: true }
  );

  const textClassName = createDashboardNavigationControlClassName('text');

  const badgeNumberClassName = createDashboardNavigationControlClassName(
    'badgeNumber'
  );

  if (to) {
    const navLinkClassName = createDashboardNavigationControlClassName(
      'navLink'
    );

    return (
      <NavLink
        className={navLinkClassName}
        activeClassName={navLinkActiveClassName}
        to={to}
      >
        <span className={textClassName}>{children}</span>
        {badgeNumber !== undefined && badgeNumber > 0 && (
          <span className={badgeNumberClassName}>{badgeNumber}</span>
        )}
      </NavLink>
    );
  }

  if (onClick) {
    const navButtonClassName = createDashboardNavigationControlClassName(
      'navButton'
    );

    return (
      <button className={navButtonClassName} onClick={onClick}>
        <span className={textClassName}>{children}</span>
        {badgeNumber !== undefined && badgeNumber > 0 && (
          <span className={badgeNumberClassName}>{badgeNumber}</span>
        )}
      </button>
    );
  }

  return null;
};
